import React from "react";
import { Box, Grid, Slide, Typography, CardMedia } from "@mui/material";

import { HeaderStyle, SecondaryStyle } from "../fonts";

const BackCover = (props) => {
  const { checked } = props;

  return (
    <Slide
      direction={"left"}
      in={checked}
      timeout={{
        enter: 1750,
        exit: 1750,
      }}
    >
      <Box
        sx={{
          height: { xs: "100svh", sm: "100vh" },
          width: "100%",
          bgcolor: "#D7D7D7",
        }}
      >
        <Grid
          container
          sx={{
            height: "100%",
            justifyContent: "center",
          }}
        >
          <Grid item xs={12} sm={9} lg={6}>
            <Grid
              container
              direction={"column"}
              sx={{ height: "100%", backgroundColor: "#FFFFFF" }}
            >
              <Grid
                item
                xs
                sx={{
                  borderLeft: "1vh solid #fff",
                  borderRight: "1vh solid #fff",
                  borderTop: "1vh solid #fff",
                }}
              >
                <CardMedia
                  component={"iframe"}
                  sx={{
                    minHeight: { lg: "55vh" },
                    border: 0,
                    height: "100%",
                    width: "100%",
                    objectFit: "cover",
                    borderRadius: "8px",
                  }}
                  src="https://unbranded.youriguide.com/591_palmerston_ave_toronto_on?page=tour&pano=20016&rotation=-3.2976880272973474&elevation=-0.002462698177116196"
                />
              </Grid>
              <Grid
                item
                xs
                sx={{
                  zIndex: 1,
                  textAlign: "center",
                  display: "flex",
                  flexDirection: "column",
                  justifyContent: "center",
                  borderBottom: ".5vh solid #ba2525",
                }}
              >
                <Typography
                  sx={{
                    ...HeaderStyle,
                    color: "#ba2525",
                    "@media (orientation: landscape)": {
                      fontSize: { xs: "2.4vw", lg: "2.2vw" },
                      lineHeight: { xs: "2.5vw", md: "2vw", lg: "2.1vw" },
                      paddingTop: { xs: "0vh", lg: "3vh" },
                    },
                    "@media (orientation: portrait)": {
                      fontSize: { xs: "7vw", sm: "5vw" },
                      lineHeight: { xs: "3.3vh", md: "3.5vh" },
                      paddingTop: { xs: "2vh", md: "3vh" },
                    },
                  }}
                >
                  591 Palmerston Ave
                </Typography>
              </Grid>
              <Grid
                item
                sx={{
                  display: "flex",
                  justifyContent: "center",
                  textAlign: "center",
                }}
              >
                <Typography
                  sx={{
                    ...SecondaryStyle,
                    opacity: 0.9,
                    "@media (orientation: landscape)": {
                      fontSize: { xs: "1vw", md: "1vw", lg: ".8vw" },
                      lineHeight: { xs: "1.7vw", md: "2vw", lg: "1.7vw" },
                      paddingTop: "0vw",
                    },
                    "@media (orientation: portrait)": {
                      fontSize: {
                        xs: "1.9vh",
                        sm: "1.6vh",
                        lg: "4vh",
                      },
                      lineHeight: "2vh",
                      paddingTop: { xs: "1vh", md: "1.5vh" },
                    },
                  }}
                >
                  Not intended to solicit Sellers or Buyers currently under
                  written contract with another Realtor
                </Typography>
              </Grid>
            </Grid>
          </Grid>
        </Grid>
      </Box>
    </Slide>
  );
};

export default BackCover;
